import { c as _c } from "react/compiler-runtime";
// The one text field: a soft rounded well with an optional leading icon (search) and an optional trailing action
// (a LinkButton, e.g. the login's Sign in). 16px text: iOS doesn't zoom the page on focus. Styles: book.css `.field`.
import type { InputHTMLAttributes, ReactNode } from "react";
type Props = InputHTMLAttributes<HTMLInputElement> & {
  t?: string;
  icon?: "search";
  action?: ReactNode;
};
export function Field(t0) {
  const $ = _c(18);
  let action;
  let className;
  let icon;
  let input;
  let t;
  if ($[0] !== t0) {
    ({
      t,
      icon,
      action,
      className,
      ...input
    } = t0);
    $[0] = t0;
    $[1] = action;
    $[2] = className;
    $[3] = icon;
    $[4] = input;
    $[5] = t;
  } else {
    action = $[1];
    className = $[2];
    icon = $[3];
    input = $[4];
    t = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = ["field", className].filter(Boolean);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = t1.join(" ");
  let t3;
  if ($[8] !== icon) {
    t3 = icon === "search" && <svg viewBox="0 0 16 16" aria-hidden={true}><circle cx="7" cy="7" r="4.5" /><path d="M10.5 10.5 14 14" /></svg>;
    $[8] = icon;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== input) {
    t4 = <input {...input} />;
    $[10] = input;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== action || $[13] !== t || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <label className={t2} data-t={t}>{t3}{t4}{action}</label>;
    $[12] = action;
    $[13] = t;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}